import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./Header.scss";
const Header = ({ className = '', children }) => {
    return (_jsx("div", { className: classNames('page-header', className), children: children }));
};
export default Header;
